export const useTerm = '';
